import { Image, Select } from 'antd';
import React from 'react';
import { SelectData } from '../../../models/common/types';
import { CreateProjectInitialValue } from '../../../models/project/types';
import { CustomSelectFormItem } from './CustomSelectUploadFileForm.styles';

const { Option } = Select;

interface Props {
    options: Array<SelectData | CreateProjectInitialValue>;
    name?: string;
    label?: string | React.ReactNode;
    placeholder?: string;
    required?: boolean;
    rules?: any;
    props?: any;
    id?: string;
    block?: boolean;
    value?: any;
    modallabel?: boolean; // Optional prop to indicate if the label is for a modal
}

const CustomSelectWithSearch: React.FC<Props> = ({
    id = 'input-container',
    label = '',
    name,
    required,
    options,
    placeholder,
    rules,
    props,
    block,
    value,
    modallabel,
}) => {
    const availableOptions = options.map((option, i) => {
        const selectOption = option as SelectData;
        return (
            <Option
                value={option.id}
                key={option.id}
                className={selectOption.className || `${name}-${i.toString()}`}
                disabled={selectOption.disabled}
            >
                {option.name}
            </Option>
        );
    });
    return (
        <div id={id} className={`${required ? 'required' : ''}  ${block ? 'input-block' : ''}`}>
            <CustomSelectFormItem
                name={name} label={
                    label ? <span className={modallabel ? 'modallabel customSelectFormItemLabel' : 'customSelectFormItemLabel'}>{label}</span> : undefined
                }
                rules={rules}
                colon={modallabel === true ? false : undefined}
            >
                <Select
                    showSearch={true}
                    optionFilterProp="children"
                    filterOption={(inputValue, option: any) => {
                        // Skip filtering for disabled items (like dividers)
                        if (option?.disabled) {
                            return false;
                        }
                        // Handle string children
                        if (typeof option?.children === 'string') {
                            return option.children.toLowerCase().includes(inputValue.toLowerCase());
                        }
                        // Skip filtering for non-string children (React components)
                        return false;
                    }}
                    aria-required
                    placeholder={placeholder}
                    value={value}
                    {...props}
                    suffixIcon={
                        <Image
                            src="src/assets/images/ic-dropdown-arrow.svg"
                            preview={false}
                            alt="caret-down"
                        />
                    }
                >
                    {availableOptions}
                </Select>
            </CustomSelectFormItem>
        </div>
    );
};

export default CustomSelectWithSearch;
